﻿import { KboOutput } from "@models/configurators/configurator-di";
import { CToken } from "@models/configurators/ctoken";
import { KbObjectManager } from "@models/configurators/kb-object-manager";
import { IBomOutput, IOutput } from "@models/entity-models";
import { eOutputType } from "@models/enums";
import { FileOutput } from "@models/configurators/outputs/file-output";

@KboOutput(CToken.BomOutput, eOutputType.bom)
export class BomOutput extends FileOutput implements IBomOutput {
    constructor(kom: KbObjectManager, args?: IOutput) {
        super(kom, args);
    }
}
